import { isDevelopment } from '@constants';
import { OfficeSingleSignOnError } from '@utils-global';

export const loginSSO = async (): Promise<string> => {
  try {
    return await OfficeRuntime.auth.getAccessToken({
      allowSignInPrompt: true,
      allowConsentPrompt: true,
      forMSGraphAccess: !isDevelopment,
    });
  } catch (error) {
    // Office rejects with an Office.Error (an interface, not a class), so it's never an Error.
    const officeError = error as Office.Error;
    throw new OfficeSingleSignOnError(officeError.message, officeError.code, {
      name: officeError.name,
    });
  }
};
